import { useState, useEffect } from "react";
import apis from '../api';

const useParamsCIR1009 = () => {
    const [params1009, setParams1009] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            let parametros = [];
            let lista = [];
            await apis.getFormat1009(payload, headers).then(res => {
                parametros = res.data["SHEETS"][0]
                //console.log(parametros);
            })
            parametros["DETAIL"].forEach((row, i) => {
                lista.push({
                    VALUE: "", LABEL: row.NAME, OPTIONS: row.DETAIL, TAG: row.LABEL,
                    SHEET: parametros.NAME, SHEET_POSITION: i, POSITION: row.POSITION, TYPE: row.TYPE_NATIVE, REQUIRED: row.REQUIRED
                })
            })
            setParams1009(lista)
            console.log(lista)
        }
        getParams()
    }, []);

    return [params1009];
};

export default useParamsCIR1009;